// Module
var code = "<template>\n    <button type=\"button\" class=\"btn btn-toggle btn-block ${value ? 'active' : ''}\" click.trigger=\"toggleValue()\" aria-label=\"${label}\">\n        <span class=\"glyphicon ${value ? 'glyphicon-check' : 'glyphicon-unchecked'}\"></span>\n    </button>\n</template>\n";
// Exports
export default code;